import React, { useState, useEffect, useContext } from "react";
import { useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import { useNavigate, useParams } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import {
  Grid,
  Typography,
  Divider,
  Tooltip,
  makeStyles,
  IconButton,
} from "@material-ui/core";
import styled from "styled-components";
import Box from "@mui/material/Box";

import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import HowToRegOutlinedIcon from '@mui/icons-material/HowToRegOutlined';
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import {
  GET_STAFF_TERMS_OF_CLIENT_QUERY,
} from "../../graphQL/user_qry";
import { GET_USER_DATA_BY_USERNAME } from "../../graphQL/register_qry";

import StaffAttendanceInfoDialog from "./StaffAttendanceInfoDialog.js";
import StaffNoteInfoDialog from "./StaffNoteInfoDialog.js";

import AlertDialog from "../../components/AlertDialog.js";
import Header from "./HeaderWithClient.js";

import { project_url } from "../../constants/Data";

const findAnd = require("find-and");

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },
  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
  dataGridTyp: {
    fontWeight: 400,
    letterSpacing: "0.01071em !important",
    fontSize: "0.875rem !important",
    // alignItems: "center",
    // justifyContent: "center",
  },
  tooltipStyle: {
    // paddingRight: 15,
    // cursor: "pointer",
    height: 24,
    weight: 24,
    paddingTop: 15,
  },
}));

function StaffTermsList() {
  const navigate = useNavigate();
  const classes = useStyles();
  const client = useContext(ClientContext);
  const [pathname] = useState(window.location.pathname);
  const [staffAttendanceInfo, setStaffAttendanceInfo] = useState(false);
  const [staffNoteInfo, setStaffNoteInfo] = useState(false);
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [selectedTermName, setSelectedTermName] = useState("");
  const [selectedTermTeams, setSelectedTermTeams] = useState([]);
  const [selectedTermRoles, setSelectedTermRoles] = useState([]);
  const [teamTermMemberIds, setTeamTermMemberIds] = useState([]);
  const { staffUuid } = useParams();

  const [rows, setRows] = useState([]);
  const [fullName, setFullName] = useState([]);
  const [loadContent, setLoadContent] = useState(false);
  const [termsAccess, setTermsAccess] = useState(true);

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  const [clientId, setClientId] = useState(
    Number(localStorage.getItem("clientId") || 0)
  );

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    const newFormat =
      dayFormat.find(a => a.type === "month").value +
      "/" +
      dayFormat.find(a => a.type === "day").value +
      "/" +
      dayFormat.find(a => a.type === "year").value;
    return newFormat;
  };

  const [fetchStaffTerms] = useManualQuery(GET_STAFF_TERMS_OF_CLIENT_QUERY, {
    fetchPolicy: "network-only",
  });
  const [getUserDataByUserName] = useManualQuery(GET_USER_DATA_BY_USERNAME);

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Staff",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {            
      let additionalActions = accessData.staffModuleAccess.additionalActions.split('|');
    
      if(additionalActions.find(a => a === "Terms")){
        setTermsAccess(true);}
      else setTermsAccess(false);
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);



  const getTermsList = async () => {
   console.log(clientId);
    const {
      loading: loadingData,
      error: errorData,
      data: dataList,
    } = await fetchStaffTerms({
      variables: {
        username: staffUuid,
        clientId: parseInt(clientId),
      },
    });
    if (!loadingData && dataList && dataList.getStaffTermsOfClient) {
      console.log(dataList.getStaffTermsOfClient)
      let tmp = [];
      let termIdTmp = [];
      for (var i in dataList.getStaffTermsOfClient) {
        let currTeam = dataList.getStaffTermsOfClient[i];
        let currTeamId = parseInt(currTeam.teamTermId.termId.termId);
        if (!termIdTmp.includes(currTeamId)) {
          termIdTmp.push(currTeamId);
          let data = {};
          data["teamTermMemberId"] = [currTeam.teamTermMemberId];
          data["termId"] = currTeamId;
          data["termName"] = currTeam.teamTermId.termId.name;
          data["termUuid"] = currTeam.teamTermId.termId.termUuid;
          data["startDate"] = currTeam.teamTermId.termId.startDate
            ? dayFormat(currTeam.teamTermId.termId.startDate)
            : "";
          data["endDate"] = currTeam.teamTermId.termId.endDate
            ? dayFormat(currTeam.teamTermId.termId.endDate)
            : "";
          data["teamRole"] = [currTeam.roleId.roleName];
          data["teamUuid"] = currTeam.teamTermId.teamId.teamUuid;
          data["teamName"] = [currTeam.teamTermId.teamId.name];
          tmp.push(data);
        } else {
          let currTermRow = findAnd.returnFound(tmp, { termId: currTeamId });
          let oldRole = [...currTermRow.teamRole];
          let oldTerm = [...currTermRow.teamName];
          let oldTeamTermMemberId = [...currTermRow.teamTermMemberId];
          tmp = findAnd.changeProps(
            tmp,
            { termId: currTeamId },
            {
              teamTermMemberId: [...oldTeamTermMemberId, currTeam.teamTermMemberId],
              teamRole: [...oldRole, currTeam.roleId.roleName],
              teamName: [...oldTerm, currTeam.teamTermId.teamId.name],
            }
          );
        }
      }
      setRows(tmp);
    }
    if (errorData) {
      if (errorData.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin`);
    }

    // Get user information
    const {
      loading: userDataLoading,
      error: userDataError,
      data: userData,
    } = await getUserDataByUserName({
      variables: { username: staffUuid },
    });
    if (!userDataLoading && userData && userData.getUserDataByUsername) {
      setFullName(
        userData.getUserDataByUsername.firstName +
          " " +
          userData.getUserDataByUsername.lastName
      );
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getTermsList())();
  }, [staffUuid, clientId]);

  const columns = [
    {
      field: "termName",
      headerName: "Term Name",
      minWidth: 120,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "startDate",
      headerName: "Start Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "endDate",
      headerName: "End Date",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
    },
    {
      field: "teamName",
      headerName: "Team",
      minWidth: 120,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        // return rows.row.teamName.map(data => (
        //   <Typography style={{ fontSize: "0.888rem", fontWeight: 500 }}>
        //     {data}
        //   </Typography>
        // ));
        return (
          <Box
            // pt={1}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {rows.row.teamName.map(data => (
              <Typography className={classes.dataGridTyp}> {data} </Typography>
            ))}
          </Box>
        );
      },
    },
    {
      field: "teamRole",
      headerName: "Role",
      minWidth: 100,
      flex: 1,
      // sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,

      renderCell: rows => {
        return (
          <Box
            // pt={1}
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            {rows.row.teamRole.map(data => (
              <Typography className={classes.dataGridTyp}> {data} </Typography>
            ))}
          </Box>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      minWidth: 240,
      flex: 2,
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableColumnMenu: true,
      renderCell: rows => {
        return (
          <Box
            // pt={1}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <StyledTooltip title="Attendance">
              <IconButton className={classes.tooltipStyle}>
                <HowToRegOutlinedIcon
                  onClick={() => {
                    setStaffAttendanceInfo(true);
                    setSelectedTerm(rows.row.termUuid);
                    setSelectedTermName(rows.row.termName);
                    setSelectedTermTeams(rows.row.teamName);
                    setSelectedTermRoles(rows.row.teamRole);
                    setTeamTermMemberIds(rows.row.teamTermMemberId);}}
                />
              </IconButton>
            </StyledTooltip>
            <StyledTooltip title="Notes">
              <IconButton className={classes.tooltipStyle}>
                <EditNoteOutlinedIcon
                  onClick={() => {
                    setStaffNoteInfo(true);
                    setSelectedTerm(rows.row.termUuid);
                    setSelectedTermName(rows.row.termName);
                    setSelectedTermTeams(rows.row.teamName);
                    setSelectedTermRoles(rows.row.teamRole);
                    setTeamTermMemberIds(rows.row.teamTermMemberId);}}
                />
              </IconButton>
            </StyledTooltip>
          </Box>
        );
      },
    },
  ];

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 15, //5,
            paddingBottom: 15, //6,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20 }}>
              Staff Terms List
            </Typography>
          </Grid>
          {/* <Grid
            item
            xs={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: 10,
            }}
          >
            <Button
              variant="contained"
              size="small"
              className={classes.buttonStyle}
              onClick={() => navigate(`${project_url}/users/add`)}
            >
              Add
            </Button>
          </Grid> */}
        </Grid>
        <Divider />
      </>
    );
  }
  if (loadContent)
    if (termsAccess)
    return (
      <div className={classes.root}>
            <Header
                breadcrumbs={[
                  { label: "Staff List", link: `${project_url}/staff/` },
                  { label: fullName, link: null },
                  { label: "Terms List", link: null },
                ]}
                staffUuid={staffUuid}
                onClientChanged={setClientId}
            />
        <div className={classes.container}>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            // hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            getRowId={row => row.termId}
            autoHeight={true}
            experimentalFeatures={{ newEditingApi: true }}
            initialState={{
              pagination: { paginationModel: { pageSize: 10 } },
              //   sorting: {
              //     sortModel: [{ field: "dateUpdated", sort: "desc" }],
              //   },
            }}
            pageSizeOptions={[10, 25, 50]}
            getRowHeight={() => "auto"}
            sx={{
              "& .MuiDataGrid-cell": {
                alignContent: "center",
                paddingTop: 1,
                paddingBottom: 1,
              },
            }}
          />
          {staffAttendanceInfo && (
            <StaffAttendanceInfoDialog
              closeDialog={() => {
                setStaffAttendanceInfo(false);
              }}
              fullName={fullName}
              staffUuid={staffUuid}
              termUuid={selectedTerm}
              termName={selectedTermName}
              termTeams={selectedTermTeams}
              termRoles={selectedTermRoles}
              teamTermMemberIds={teamTermMemberIds}
            />
          )}
          {staffNoteInfo && (
            <StaffNoteInfoDialog
              closeDialog={() => {
                setStaffNoteInfo(false);
              }}
              fullName={fullName}
              staffUuid={staffUuid}
              termUuid={selectedTerm}
              termName={selectedTermName}
              termTeams={selectedTermTeams}
              termRoles={selectedTermRoles}
              teamTermMemberIds={teamTermMemberIds}
            />
          )}
        </div>
      </div>
    );
    else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default StaffTermsList;